import { memo } from "react";
import { findIndex, map } from "lodash";
import { Flex, Box, H5, Divider } from "orcs-design-system";
import {
  useInsightsData,
  useInsightsDispatch,
} from "src/contexts/valueGraphInsights";
import { ACTION } from "src/contexts/valueGraphInsights/strategyInsights/reducer/action";
import InsightPanel from "./components/InsightPanel";
import type { Insight } from "./types";

const StrategyInsights = () => {
  const insightsData: Insight[] | undefined = useInsightsData();
  const dispatch = useInsightsDispatch();

  const handleClickToTheTop = (type: string) => {
    const clonedTeams = [...(insightsData || [])];
    const selectedInsightIndex = findIndex(clonedTeams, { type });
    if (selectedInsightIndex === 0) {
      return;
    }
    const removedItem = clonedTeams.splice(selectedInsightIndex, 1);
    const [firstRemoved] = removedItem;
    if (firstRemoved) {
      clonedTeams.unshift(firstRemoved);
    }
    dispatch({
      type: ACTION.SET_INSIGHTS_ORDER,
      payload: map(clonedTeams, "type"),
    });
  };

  return (
    <div id="keep-open-on-click-outside">
      <H5 fontWeight="bold">Team alignment</H5>
      <Box my="r">
        <Divider light />
      </Box>
      <Flex flexDirection="column">
        {map(insightsData, (insight, index) => {
          return (
            <Box my="r" key={index}>
              <InsightPanel
                handleClickToTheTop={handleClickToTheTop}
                insight={insight}
              />
            </Box>
          );
        })}
      </Flex>
    </div>
  );
};

export default memo(StrategyInsights);
